import { LuLoader } from "react-icons/lu";

const LoaderComponent = () => {
  return (
    <div className="w-full flex justify-center items-center">
    <LuLoader size={80} className='animate-spin animate-speed-faster' style={{animationDuration: "350ms"}} />
  </div>
  );
};

export default LoaderComponent;
